import {Song} from '../types';
import {CurrentSongContextProviderValue} from '../context/CurrentSongProvider';
import {QueueContextProviderValue} from '../context/QueueProvider';
import {MetaData} from '../controllers/Obsidian';
import {useState} from 'react';
import {useTimer} from '../hooks';

function useCurrentSong(
  queue: QueueContextProviderValue,
): CurrentSongContextProviderValue {
  const [currentSong, setCurrentSong] = useState<Song | null>(null);
  const [musicLoading, setMusicLoading] = useState(false);
  const [buffer, setBuffer] = useState<number>(0);
  const timer = useTimer();
  const [playing, setPlaying] = useState(false);
  const [songMetaData, setSongMetaData] = useState<MetaData | undefined>();
  const [volume, setVolume] = useState(100);

  const handleNext = () => {
    if (queue.songs.length > 0) {
      const nextSong = queue.songs[0];
      setCurrentSong(nextSong);
      queue.set(queue.songs.slice(1));
      return nextSong;
    } else if (queue.upNextSongs.length > 0) {
      const nextSong = queue.upNextSongs[0];
      setCurrentSong(nextSong);
      queue.setUpNext(queue.upNextSongs.slice(1));
      return nextSong;
    } else {
      setCurrentSong(null);
    }
  };

  return {
    song: currentSong,
    setCurrentSong,
    musicLoading,
    setMusicLoading,
    timer,
    playing,
    setPlaying,
    songMetaData,
    setSongMetaData,
    volume,
    setVolume,
    next: handleNext,
    previous: () => {},
    buffer,
    setBuffer,
  };
}

export default useCurrentSong;
